import React, { useContext, useEffect, useState } from "react";
import "./Login.scss";
import "./LoginMobile.scss";
import Button from "@components/button/Button";
import { useForm } from "react-hook-form";
import Input from "@components/input/Input";
import SlideShow from "@components/slideShow/SlideShow";
import UtilServices from "@services/UtilServices";
import Loading from "@components/loading/Loading";
import useLoading from "@hooks/useLoading";
import GlobalContext from "@context/GlobalContext";
import { ToastContainer } from "react-toastify";
import MessageServices from "@services/MessageServices";
import EndPointServices from "@services/ApiServices";
import { useNavigate } from "react-router-dom";
import Modal from "@components/modal/Modal";
import useAutenticar from "@hooks/useAutenticar";
import Captcha from "@components/captcha/Captcha";
import { useTurnstile } from "react-turnstile";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      login:
        process.env.NODE_ENV === "development" ? "useradmin@admin.com" : "",
      senha: process.env.NODE_ENV === "development" ? "admin941360@" : "",
    },
  });

  const [setLoading] = useLoading();
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const { handleLogout } = useAutenticar();
  const [idLogin, setIdLogin] = useState([]);

  //Mudar senha
  const [senhaAntiga, setSenhaAntiga] = useState("");

  //Captcha
  const [countTentativa, setCountTentativa] = useState(0);
  const turnstile = useTurnstile();
  const [tokenVerificado, setTokenVerificado] = useState(false);

  function handleMapPermissoes(array) {
    let permissoes = [];

    array.forEach((item) => {
      const {
        Nome_App,
        ID_App,
        Nome_App_Compo,
        Nome_Funcionalidade,
        ID_Perfil,
        Nome_Perfil,
      } = item;

      // Verifica se já existe um perfil com esse ID e App
      let perfilExistente = permissoes.some(
        (p) => p.idPerfil === ID_Perfil && p.idApp === ID_App,
      );

      if (!perfilExistente) {
        // Adiciona um novo perfil ao array
        permissoes.push({
          idApp: ID_App,
          nomeApp: Nome_App,
          Compo: {},
          idPerfil: ID_Perfil,
          nomePerfil: Nome_Perfil,
        });
      }

      // Encontra o perfil correspondente
      let perfil = permissoes.find(
        (p) => p.idPerfil === ID_Perfil && p.idApp === ID_App,
      );

      // Se o menu ainda não existe dentro do perfil, criamos ele
      if (!perfil.Compo[Nome_App_Compo]) {
        perfil.Compo[Nome_App_Compo] = [];
      }

      // Adicionamos a funcionalidade se ainda não estiver na lista
      if (!perfil.Compo[Nome_App_Compo].includes(Nome_Funcionalidade)) {
        perfil.Compo[Nome_App_Compo].push(Nome_Funcionalidade);
      }
    });

    return permissoes;
  }
  async function handleLogin(data) {
    setLoading(true);

    let loginsenha = data;

    //Validar se a senha é a mesma digitada para mudar senha.
    setSenhaAntiga(loginsenha.senha);

    //se a verificação for false ele retorna o erro.
    if (!tokenVerificado) {
      MessageServices.ShowError(
        "O token de verificação do CAPTCHA é inválido.",
      );
      setLoading(false);
      return;
    }

    //se for cpf ele tira os caracteres
    if (UtilServices.validateCPF(loginsenha.login)) {
      loginsenha.login = loginsenha.login.replace(/[^\d]+/g, ""); // Remove caracteres não numéricos
    }
    try {
      /*--Autentica Login--*/
      var retornoapi = await EndPointServices.Autentica_Login(data);
      if (retornoapi.Success) {
        //VERIFICAR SE A SENHA É MUDAR123
        if (loginsenha.senha === "Mudar123") {
          setIdLogin({
            ID_Usuario: retornoapi?.BaseReturn?.LstClasse[0].ID_Usuario,
            ID_Usuario_Log: retornoapi?.BaseReturn?.LstClasse[0].ID_Usuario_Log,
          });
          setShowModal(true);
          setLoading(false);
          handleLogout();
          return;
        }
        //recupera o token.
        UtilServices.managerToken(retornoapi?.BaseReturn?.Classe);

        //Seta Dados do Usuario
        UtilServices.setStorage(
          "dadosusuario",
          retornoapi?.BaseReturn?.LstClasse[0],
        );

        dispatch({
          type: "SET_USUARIO",
          payload: retornoapi?.BaseReturn?.LstClasse[0],
        });

        //set as permissões do usuario
        if (retornoapi?.BaseReturn?.LstClasse.length > 0) {
          data = {
            ID_Usuario: retornoapi?.BaseReturn?.LstClasse[0].ID_Usuario,
            ID_Usuario_Log: retornoapi?.BaseReturn?.LstClasse[0].ID_Usuario_Log,
          };
        }
      }

      /*--Permissões--*/
      retornoapi = await EndPointServices.Autentica_Permissoes(data);
      if (retornoapi.Success) {
        let lstPermissoes = handleMapPermissoes(
          retornoapi?.BaseReturn?.LstClasse,
        );

        console.log("lstPermissoes", lstPermissoes);
        //Seta permissões do usuario
        UtilServices.setStorage("permissoesusuario", lstPermissoes);
        dispatch({
          type: "SET_PERMISSOES",
          payload: lstPermissoes,
        });

        //Seta perfil selecionado.
        let perfilselecionado = UtilServices.perfilFiltrarMenor(
          lstPermissoes,
          "CAD",
        ); //Default App CAD

        UtilServices.setStorage("perfilselecionado", perfilselecionado);
        dispatch({
          type: "SET_PERFILSELECIONADO",
          payload: perfilselecionado,
        });
      }

      /*--Notificação--*/
      retornoapi = await EndPointServices.ALT_ConsultaNotificacaoContagem(data);
      if (retornoapi.Success) {
        let countNotificacao =
          retornoapi?.BaseReturn?.Classe?.[0]?.totalnotificacao?.toLocaleString(
            "pt-BR",
          ) ?? 0;

        //Seta a notificacao.
        UtilServices.setStorage("notificacao", countNotificacao);
        dispatch({
          type: "SET_NOTIFICACAO",
          payload: countNotificacao,
        });

        MessageServices.ShowSuccess(
          "Login realizado com sucesso! Você será redirecionado em instantes.",
        );

        //2 segundos para o redirecionamento.
        setTimeout(() => {
          reset(); //Reseta todos useForm
          navigate("/home");
        }, 2000);
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoading(false);
  }
  async function handleMudarSenha(e) {
    setLoading(true);

    if (senhaAntiga === e?.senhamudar) {
      MessageServices.ShowWarning(
        "A nova senha não pode ser igual à anterior.",
      );
      setLoading(false);
      return;
    }

    //Dar insert no banco de dados
    e.senha = e?.senhamudar;
    e.ID_Usuario = idLogin?.ID_Usuario;
    e.ID_Usuario_Log = idLogin?.ID_Usuario_Log;

    try {
      var retornoapi = await EndPointServices.Autentica_MudarSenha(e);
      if (retornoapi.Success) {
        MessageServices.ShowSuccess("Senha alterada com sucesso.");
        setShowModal(false);
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoading(false);
    handleLogin(e);
  }
  async function handleVerify(tokenCaptcha) {
    let data = {
      Token: tokenCaptcha,
    };
    try {
      let resp = await EndPointServices.Externo_VerificaTokenCaptcha(data);

      let respJson = typeof resp === "string" ? JSON.parse(resp) : resp;

      if (respJson?.success) {
        setTokenVerificado(true);
      } else {
        handleOnErrorCaptcha();
      }
    } catch (ex) {
      console.error("Erro Captcha: ", ex);
      handleOnErrorCaptcha();
    }
  }
  function handleOnErrorCaptcha() {
    if (countTentativa <= 2) {
      //faz 3 tentativas no captcha.
      setTimeout(() => {
        turnstile.reset();
        setCountTentativa(countTentativa + 1);
      }, 2000);
    } else {
      MessageServices.ShowError("Ocorreu um erro na validação do CAPTCHA.");
    }
  }

  return (
    <div className="login">
      <div className="login-b row">
        <div className="col-7 login-c login-c1">
          <SlideShow
            images={[
              {
                img: `imgs/slides/slide-img${
                  UtilServices.getStorage("tema") === "light"
                    ? "4.png"
                    : "1.png"
                }`,
                txt: "Solução rápida, inovadora e eficaz",
              },
              {
                img: `imgs/slides/slide-img${
                  UtilServices.getStorage("tema") === "light"
                    ? "5.png"
                    : "2.png"
                }`,
                txt: "Melhor tecnologia e maior desempenho",
              },
              {
                img: `imgs/slides/slide-img${
                  UtilServices.getStorage("tema") === "light"
                    ? "6.png"
                    : "3.png"
                }`,
                txt: "Automatização de tarefas e organização",
              },
            ]}
          />
        </div>
        <form
          className="col-5 login-c login-c2"
          onSubmit={handleSubmit(handleLogin)}
        >
          <div>
            <div className="login-bemvindo">
              <p>Bem vindo.</p>
              <p className="login-texto-acesse">Acesse com CPF ou Email</p>
            </div>
            <div className="login-login">
              <Input
                placeholder="Login"
                setValue={setValue}
                register={register}
                errors={errors}
                name="login"
                mask="CPF"
                registerProps={{
                  required: "O Login é obrigatório",
                }}
                type="cpfemail"
              />
            </div>
            <div className="login-senha">
              <Input
                placeholder="Senha"
                type="password"
                setValue={setValue}
                register={register}
                errors={errors}
                registerProps={{
                  required: "Senha é obrigatório",
                  validate: {
                    minLength: (value) =>
                      value.length >= 8 ||
                      "a senha deve ter no mínimo 8 caracteres",
                  },
                }}
                name="senha"
              />
            </div>
            <Captcha
              onVerify={handleVerify}
              sitekey={
                process.env.NODE_ENV === "development"
                  ? "1x00000000000000000000AA"
                  : "0x4AAAAAABC6x_zBJGBeMduh"
              }
            />
            <div className="login-button-entrar">
              <Button nome="Acessar" disabled={!tokenVerificado} />
            </div>
            <div className="login-cadastrar">
              <a
                onClick={() => {
                  MessageServices.ShowWarning("#Em Desevolvimento!");
                }}
              >
                Cadastrar-se
              </a>
            </div>
          </div>
        </form>
      </div>
      <Loading type="spin" show={state.loading} color="#c1abff" />
      <ToastContainer />
      <Modal
        botaoExcluir={false}
        showModal={showModal}
        setShowModal={setShowModal}
        title="Alerta"
        width="350px"
      >
        <form onSubmit={handleSubmit(handleMudarSenha)}>
          <div>
            <p className="login-alterarsenha-texto">
              Por favor, redefina sua senha para autenticação.
            </p>
            <div className="login-alterarsenha">
              <Input
                placeholder="Nova Senha"
                type="password"
                setValue={setValue}
                register={register}
                errors={errors}
                registerProps={{
                  required: "Senha é obrigatório",
                  validate: {
                    minLength: (value) =>
                      value.length >= 8 ||
                      "a senha deve ter no mínimo 8 caracteres",
                  },
                }}
                theme="4"
                name="senhamudar"
              />
              <Input
                placeholder="Confirmar Senha"
                type="password"
                setValue={setValue}
                register={register}
                errors={errors}
                registerProps={{
                  required: "Confirme a senha é obrigatório",
                  validate: {
                    isValid: (value) =>
                      value === watch("senhamudar") ||
                      "A senha que você digitou não corresponde",
                  },
                }}
                theme="4"
                name="copiarsenhamudar"
              />
              <div className="login-alterarsenha-button">
                <Button nome="Alterar" />
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Login;
